const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTapToInteract(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      backgroundColor: "rgba(255, 255, 255, 0)",
      display: "block",
      shapeRendering: "auto",
      animationPlayState: "running",
      animationDelay: "0s",
      backgroundPosition: "initial initial",
      backgroundRepeat: "initial initial"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 0,
    fill: "none",
    stroke: "#00b0a6",
    strokeWidth: 6,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    repeatCount: "indefinite",
    dur: "2.941176470588235s",
    values: "0;13",
    keyTimes: "0;1",
    keySplines: "0 0.2 0.8 1",
    calcMode: "spline",
    begin: "0s",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "2.941176470588235s",
    values: "1;0",
    keyTimes: "0;1",
    keySplines: "0.2 0 0.8 1",
    calcMode: "spline",
    begin: "0s",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 0,
    fill: "none",
    stroke: "#00b0a6",
    strokeWidth: 6,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    repeatCount: "indefinite",
    dur: "2.941176470588235s",
    values: "0;13",
    keyTimes: "0;1",
    keySplines: "0 0.2 0.8 1",
    calcMode: "spline",
    begin: "-1.4705882352941175s",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "2.941176470588235s",
    values: "1;0",
    keyTimes: "0;1",
    keySplines: "0.2 0 0.8 1",
    calcMode: "spline",
    begin: "-1.4705882352941175s",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTapToInteract);
export default __webpack_public_path__ + "static/media/TapToInteract.92e7ac7942e6bfcb45ffc69b4a919eee.svg";
export { ForwardRef as ReactComponent };